import { PubSub, ScrollLock, CssModifiers } from '../utils/'

let $cookieWidget

const STATES = {
  NOT_RESPONDED: 'm-not-responded',
  EDITING: 'm-is-editing'
}

const COOKIE_KEYS = {
  DECLINED: 'declined_marketing_cookies',
  RESPONDED: 'cookie_response_recorded'
}

const STORAGE_KEY = 'cookieStatus'
const EVENTS = {
  UPDATE_STATUS: 'cookiewidget:updatestatus'
}

let cookiePath = document.cookie.match(/_site_url_name=(\w+)/)[1]
if (cookiePath == null) cookiePath = location.pathname.split('/')[1]

let psUsCookies = document.cookie.match(/(_ps_us_\d+)/ig)
if (psUsCookies == null) psUsCookies = []

const psMktCookies = ['tracking_done', 'ps_user', ...psUsCookies]

// Action mappings to inner methods from cookie widget markup
const actions = {
  acceptAll: acceptAllCookies,
  acceptPrefs: acceptPreferences,
  editPrefs: editPreferences
}

/**
 * Generates a future timestamp 1 year ahead of now
 * @returns {String} - UTC Date time string
 */
const getNextYear = () => {
  const date = new Date()
  date.setFullYear(date.getFullYear() + 1)
  return date.toUTCString()
}

/**
 * Sets a client cookie
 * @param {Object} data - Cookie property parameters
 */
const setCookie = data => {
  const { name, value, path, date } = data
  document.cookie = `${name}=${value}; path=${path}; expires=${date};`
}

/**
 * Initializes this module
 */

function init() {
  $cookieWidget = document.querySelector('.ps-cookie-widget')
  if ($cookieWidget == null) return

  PubSub.subscribe(EVENTS.UPDATE_STATUS, updateCookieStatus)

  CssModifiers.toggle($cookieWidget, notResponded(), STATES.NOT_RESPONDED)

  updateGtmDataLayer(getCookieStatus());

  addEventListeners()
}


/**
 * Gets the statuses of all cookie options
 * @returns {Object} - Stored or default cookie option statuses
 */
function getCookieStatus() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY)) || { marketing: true, analytics: true }
}

/**
 * Publish cookie status changes to all channels
 * @param {Object} status - the status of each cookie option
 */
function updateCookieStatus(status) {
  const cookiesStatus = Object.assign({}, getCookieStatus(), status)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(cookiesStatus))

  CssModifiers.remove($cookieWidget, STATES.NOT_RESPONDED)
  CssModifiers.remove($cookieWidget, STATES.EDITING)

  updateGtmDataLayer(getCookieStatus())
  ScrollLock.release()

  if (cookiesStatus.marketing == false) declineMarketingCookies()
  setCookie({ name: COOKIE_KEYS.RESPONDED, path: `/${cookiePath}`, date: getNextYear(), value: 'true' })
}


/**
 * Stores the user configured cookie option statuses
 */
function acceptPreferences() {
  const data = {}
  const $toggles = $cookieWidget.querySelectorAll('input[type="checkbox"]')

  $toggles.forEach(toggle => data[toggle.dataset.cookieType] = toggle.checked)

  PubSub.publish(EVENTS.UPDATE_STATUS, data)
}


/**
 * Sets the required css modifiers to display the cookie option editing panel
 */
function editPreferences() {
  CssModifiers.remove($cookieWidget, STATES.NOT_RESPONDED)
  CssModifiers.add($cookieWidget, STATES.EDITING)
  ScrollLock.lock()
}


/**
 * Sets all cookie options to true (accepted)
 */
function acceptAllCookies() {
  PubSub.publish(EVENTS.UPDATE_STATUS, { marketing: true, analytics: true })
}

/**
 * Iterates over given cookie objection statuses to update google tag manager object
 * @param {Object} statuses
 */
function updateGtmDataLayer(statuses) {
  for (const type in statuses) {
    const eventName = `${type}_${(statuses[type] == true ? 'enable' : 'disable')}`
    const eventExists = window.dataLayer && window.dataLayer.filter(obj => obj.event === eventName).length > 0

    if (eventExists == false) window.dataLayer.push({ 'event': eventName })
  }
}


/**
 * Destroys all marketing cookies and sets an arbitrary cookie to block any further marketing cookies being generated
(as set in back end)
 */
function declineMarketingCookies() {
  removeAllMarketingCookies();
  // Set a cookie to block ongoing server cookie creation
  setCookie({ name: COOKIE_KEYS.DECLINED, path: cookiePath, date: getNextYear(), value: 'true' })
}


/**
 * Checks whether the cookie notice has been responded to
 * @returns {Boolean} The assertion 
 */
function notResponded() {
  return RegExp(COOKIE_KEYS.RESPONDED, 'g').test(document.cookie) == false
}


/**
 * Sets all marketing cookies to expired thus deleting them
 */
function removeAllMarketingCookies() {
  const date = new Date()
  date.setFullYear(date.getFullYear() - 1)

  psMktCookies.forEach(name =>
    setCookie({ name: name, path: cookiePath, date: date.toUTCString(), value: '' })
  )
}


/**
 * Simulates event delegation from the widget's root
 */
function delegateClick(e) {
  const dataset = e.target.dataset
  const action = dataset && dataset.cookieAction

  if (!action || actions.hasOwnProperty(action) == false) return

  actions[action](e)
}


function addEventListeners() {
  $cookieWidget.addEventListener('click', delegateClick)
}


const CookieWidget = { init }
export default CookieWidget



// WEBPACK FOOTER //
// ./js/core/CookieWidget.js